































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
import { active } from 'sortablejs';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCREST: FCREST, VUE_APP_API } = process.env;
const API = {
  config: `${FCREST}/promotion/shang/mina/config`,
  banner_count: `${VUE_APP_API}/qy/weixin/mina/banner/getCount`,
};

interface Form {
  [key: string]: any;
  activity_title: string;
  activity_button_text: string;
  activity_style: number;
  ware_title: string;
  ware_button_text: string;
  ware_style: number;
  merchant_id?: number | string;
}

@Component
export default class HomePage extends Vue {
  is_dev: boolean = false; // 判断当前环境
  is_first_comming: boolean = false;
  is_loading: boolean = false;
  is_btn_loading: boolean = false;
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 19 },
  };
  banner_count: number | undefined = 0;
  form: Form = {
    activity_title: '',
    activity_button_text: '',
    activity_style: 1,
    ware_title: '',
    ware_button_text: '',
    ware_style: 1,
    merchant_id: '',
    ware_layout: 1
  };

  get inputTitle() {
    return 10;
  }

  get inputButton() {
    return 4;
  }

  @changeLoading(['is_btn_loading'])
  async handelSave() {
    const data = this.is_first_comming
      ? await this.$axios.post(API.config, this.form)
      : await this.$axios.put(`${API.config}/${this.form.merchant_id}`, {
          ...this.form,
          merchant_id: undefined,
          create_time: undefined,
        });
    if (data.data.message === 'success') {
      this.$message.success('保存成功', 3);
      this.is_first_comming = false;
    } else {
      this.$message.error('保存失败', 3);
    }
  }
  created() {
    this.is_dev = process.env.VUE_APP_STAGE === 'dev';
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    if (merchant_id) {
      this.form.merchant_id = merchant_id || '';
    } else {
      this.$message.error('获取不到商家ID,需要重新登陆', 3);
      this.$router.push({ path: '/login' });
    }
    this.is_loading = true;
    Promise.race([
      this.$axios.get(`${API.config}/${this.form.merchant_id}`).then(({ data: { data } }) => {
        if (data.merchant_id) {
          this.form = data;
          this.form.id = undefined;
          this.is_first_comming = false;
        } else {
          this.is_first_comming = true;
        }
      }),
      this.$axios.get(API.banner_count).then(({ data: { data } }) => {
        this.banner_count = data.count;
      }),
    ]).finally(() => {
      this.is_loading = false;
    });
  }
}
